import useTranslation from 'next-translate/useTranslation';
import { ManagerType } from 'types/customer';

type QuickContactProps = {
    manager: ManagerType | null;
    quickContact: string | null;
};

export const QuickContact: FC<QuickContactProps> = ({ manager, quickContact }) => {
    const { t } = useTranslation();

    return (
        <>
            {manager && (manager.email || manager.telephone) && (
                <>
                    <span className="block pb-3.5">{t('Contact to manager')}</span>
                    <div>
                        <span className="block">{manager.fullName}</span>
                        {manager.telephone && (
                            <span className="block">
                                {t('tel')}:{' '}
                                <a href={`tel:${manager.telephone}`} className="text-red no-underline">
                                    {manager.telephone}
                                </a>
                            </span>
                        )}
                        {manager.email && (
                            <span className="block">
                                <a href={`mailto:${manager.email}`} className="break-words text-red no-underline">
                                    {manager.email}
                                </a>
                            </span>
                        )}
                    </div>
                </>
            )}
            {quickContact && (
                <>
                    <span className="block py-3.5">{t('Quick contact')}</span>
                    <div dangerouslySetInnerHTML={{ __html: quickContact }} />
                </>
            )}
        </>
    );
};
